import * as React from 'react';

const OrangeSearchIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 264 110" {...props}>
        <g
            id="orange-search-illustration_svg__Page-1"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="orange-search-illustration_svg__illustration_orange_search">
                <path
                    d="M63.969 102.974c0 3.405-14.32 6.165-31.985 6.165C14.32 109.14 0 106.38 0 102.974c0-3.405 14.32-6.166 31.984-6.166 17.665 0 31.985 2.761 31.985 6.166"
                    id="orange-search-illustration_svg__Fill-1"
                    fill="#0D2223"
                />
                <path
                    d="M150.85 76.326s25.574-10.39 32.986-17.799C189.435 52.932 202.84 32.8 202.84 32.8l13.512 4.88s-2.793 16.632-11.762 31.205c-8.97 14.573-23.27 30.965-23.27 30.965l-30.47-23.523z"
                    id="orange-search-illustration_svg__Fill-4"
                    fill="#FB8825"
                />
                <path
                    d="M213.646 35.675s4.947-8.891 5.026-17.014c.079-8.123-.247-13.797-2.513-13.797s-2.513 3.938-2.513 3.938.318 5.457-1.338 8c-1.656 2.542-3.693 2.542-3.948 4.32-.254 1.78 3.057 3.305 3.057 3.305s-1.348 6.12-5.132 8.589c-3.783 2.47 7.361 2.659 7.361 2.659"
                    id="orange-search-illustration_svg__Fill-6"
                    fill="#DB5A2C"
                />
                <path
                    d="M216.48 7.918c1.252-2.3 1.78.573 1.78.573s.85-8.703-2.106-8.487c-2.957.216-4.566 4.099-4.566 6.114 0 2.016-.429 6.795-1.678 8.522-1.25 1.728-3.095 3.4-3.31 5.322-.217 1.921 4.722 4.847 4.722 4.847l.62-2.127s-1.257-1.663-.343-3.606c.914-1.944 2.834-4.218 3.294-5.713.448-1.457.559-3.557 1.587-5.445"
                    id="orange-search-illustration_svg__Fill-8"
                    fill="#363A43"
                />
                <path
                    d="M206.617 42.893a.498.498 0 01-.465-.678c.878-2.251 1.382-3.716 1.387-3.731a.498.498 0 11.944.323c-.006.014-.515 1.497-1.4 3.768a.5.5 0 01-.466.318m-3.529 8.257a.499.499 0 01-.451-.709c.586-1.253 1.13-2.474 1.628-3.627a.498.498 0 11.917.394 131.67 131.67 0 01-1.64 3.655.498.498 0 01-.454.287m-4.161 7.951a.499.499 0 01-.43-.751 78.784 78.784 0 001.934-3.462.5.5 0 01.883.464 79.829 79.829 0 01-1.958 3.505.499.499 0 01-.43.244m-5.263 7.255a.497.497 0 01-.37-.832l.51-.567c.65-.728 1.32-1.56 1.989-2.476a.499.499 0 01.805.587c-.688.942-1.378 1.8-2.05 2.552l-.514.571a.498.498 0 01-.37.165m-6.186 6.503a.5.5 0 01-.355-.849c.902-.906 1.835-1.858 2.782-2.847a.498.498 0 11.721.689c-.95.992-1.888 1.95-2.794 2.86a.5.5 0 01-.354.147m-6.462 6.236a.498.498 0 01-.34-.863c.827-.768 1.809-1.69 2.896-2.735a.498.498 0 11.692.718 242.691 242.691 0 01-2.909 2.746.498.498 0 01-.34.134"
                    id="orange-search-illustration_svg__Fill-10"
                    fill="#DB5A2C"
                />
                <path
                    id="orange-search-illustration_svg__Fill-12"
                    fill="#F7682F"
                    d="M202.902 31.406l14.77 5.021-1.32 5.184-16.696-5.937z"
                />
                <path
                    d="M216.153.004c2.958-.216 2.108 8.487 2.108 8.487l-.02-.091c.4 2.447.472 6.013.431 10.26-.068 6.976-3.717 14.501-4.749 16.493l3.748 1.274-1.319 5.184-.768-.274c-1.34 5.705-4.594 17.148-10.994 27.547-8.97 14.573-23.27 30.965-23.27 30.965l-15.704-12.124s20.154-3.008 37.532-32.675C216.998 31.406 216.153.004 216.153.004"
                    id="orange-search-illustration_svg__Fill-14"
                    fill="#F9E9C5"
                />
                <path
                    d="M69.865 22.256S42.033 40.202 35.755 54.4c-6.278 14.198-6.478 51.563-6.478 51.563h9.78s4.854-27.367 12.685-41.24c7.83-13.872 32.243-23.111 32.243-23.111l-14.12-19.355z"
                    id="orange-search-illustration_svg__Fill-16"
                    fill="#363A43"
                />
                <path
                    d="M50.881 66.324s3.476-8.847 18.097-17.29c5.432-3.136-10.202-18.871-10.202-18.871s-10.18 7.466-16.82 15.003l8.925 21.158z"
                    id="orange-search-illustration_svg__Fill-18"
                    fill="#282C35"
                />
                <path
                    d="M230.16 102.996l-.147-12.87-79.163-13.8s49.79-43.773 2.282-43.528l-23.91 70.198h100.937"
                    id="orange-search-illustration_svg__Fill-20"
                    fill="#FFA71A"
                />
                <path
                    d="M230.144 97.218l4.092 1.785s-.647-5.813 1.94-5.227c2.59.585 7.119 3.994 11.649 4.52 4.53.524 12.003-.568 12.326 2.031.12.969-.435 2.578-.435 2.578l-29.572.09v-5.777z"
                    id="orange-search-illustration_svg__Fill-22"
                    fill="#F7682F"
                />
                <path
                    d="M38.487 47.906c-3.593-5.077-10.63-6.286-15.716-2.7-5.087 3.587-6.298 10.61-2.705 15.687s10.63 6.285 15.717 2.699c5.087-3.586 6.297-10.61 2.704-15.686"
                    id="orange-search-illustration_svg__Fill-24"
                    fill="#FFA71A"
                />
                <path
                    d="M35.594 49.946c-2.465-3.483-7.29-4.311-10.78-1.852a7.71 7.71 0 00-1.855 10.759c2.465 3.482 7.291 4.312 10.78 1.851a7.71 7.71 0 001.855-10.758"
                    id="orange-search-illustration_svg__Fill-26"
                    fill="#FFF"
                />
                <path
                    id="orange-search-illustration_svg__Fill-28"
                    fill="#FFA71A"
                    d="M48.946 77.315l-4.396 3.1L32.721 63.7l4.396-3.1z"
                />
                <path
                    d="M69.865 22.256S98.977 3.87 136.755 7.083c24.28 2.065 43.742 12.747 46.542 32.712 2.8 19.964-24.02 53.536-24.02 53.536h41.344l3.817 8.81-78.278 1.172s-9.873-2.133-5.07-13.177c8.132-18.698 16.833-35.086 16.833-35.086L77.7 49.114l-7.836-26.858z"
                    id="orange-search-illustration_svg__Fill-30"
                    fill="#FFA71A"
                />
                <path
                    d="M158.832 11.982c-6.547-2.591-14.049-4.217-22.077-4.9-37.778-3.212-66.89 15.174-66.89 15.174L77.7 49.114l60.222 5.936 20.91-43.068z"
                    id="orange-search-illustration_svg__Fill-32"
                    fill="#363A43"
                />
                <path
                    d="M84.18 35.675c14.347-1.955 20.177 11.823 18.875 22.605-1.301 10.78-7.744 47.342-10.776 48.585-6.319 2.59-11.864-4.885-11.864-4.885s-1.204-27.815-.11-42.989c1.095-15.173-4.918-22.119 3.874-23.316"
                    id="orange-search-illustration_svg__Fill-34"
                    fill="#363A43"
                />
                <path
                    d="M79.991 74.595s5.872-1.784 6.267-7.275c.313-4.351.199-9.286 2.821-11.925 2.623-2.638 5.325-7.892 5.329-11.255.008-6.117-4.095-10.933-7.524-13.116 0 0-.498-3.313-2.899-5.384-2.764-2.382-9.15-3.973-9.15-3.973l4.47 35.473.686 17.455z"
                    id="orange-search-illustration_svg__Fill-36"
                    fill="#282C35"
                />
                <path
                    d="M87.101 87.074S54.116 70.59 47.86 69.488L40.836 71.7l44.007 34.262 2.258-18.888z"
                    id="orange-search-illustration_svg__Fill-38"
                    fill="#363A43"
                />
                <path
                    d="M47.859 69.488s-4.923-3.268-7.305-4.03c-2.087-.67-5.976.866-5.976.866s-1.193 1.358-.388 2.94c.805 1.58 6.646 2.436 6.646 2.436"
                    id="orange-search-illustration_svg__Fill-40"
                    fill="#F7682F"
                />
                <path
                    d="M152.84 31.383c-.012 0-.024 0-.037-.002a23.6 23.6 0 00-1.948-.06c-.318-.02-.502-.218-.506-.493a.498.498 0 01.493-.504c.667-.008 1.352.014 2.035.065a.498.498 0 01-.036.994"
                    id="orange-search-illustration_svg__Fill-42"
                    fill="#FB8825"
                />
                <path
                    d="M160.917 33.804a.494.494 0 01-.264-.076c-.983-.613-2.101-1.12-3.324-1.504a.499.499 0 11.3-.95 15.5 15.5 0 013.553 1.61.497.497 0 01-.265.92m5.04 6.61a.499.499 0 01-.477-.352 11.617 11.617 0 00-1.557-3.253.497.497 0 11.819-.568 12.603 12.603 0 011.693 3.531.498.498 0 01-.477.643m.075 8.394a.498.498 0 01-.488-.603c.305-1.412.487-2.643.54-3.659a.499.499 0 01.997.052c-.057 1.069-.245 2.353-.562 3.817a.499.499 0 01-.487.393m-2.39 8.164a.498.498 0 01-.472-.66c.437-1.261.83-2.464 1.17-3.578a.5.5 0 01.955.29 103.041 103.041 0 01-1.183 3.613.499.499 0 01-.47.335m-3.018 7.96a.5.5 0 01-.463-.686c.475-1.17.94-2.344 1.387-3.51a.498.498 0 11.931.356 191.904 191.904 0 01-1.393 3.528.498.498 0 01-.462.311m-3.33 7.834a.499.499 0 01-.455-.699 309.681 309.681 0 001.506-3.464.5.5 0 01.918.391 303.212 303.212 0 01-1.511 3.475.5.5 0 01-.457.297m-3.537 7.746a.498.498 0 01-.452-.71 378.126 378.126 0 001.593-3.428.5.5 0 01.907.414 371.538 371.538 0 01-1.596 3.437.499.499 0 01-.452.287"
                    id="orange-search-illustration_svg__Fill-44"
                    fill="#FB8825"
                />
                <path
                    d="M152.826 86.82a.468.468 0 01-.07-.005l-1.976-.279a.5.5 0 01-.376-.715c0-.002.322-.646.876-1.781a.498.498 0 11.898.436l-.575 1.17 1.293.183a.498.498 0 01-.07.991"
                    id="orange-search-illustration_svg__Fill-46"
                    fill="#FB8825"
                />
                <path
                    d="M161.204 88a.468.468 0 01-.07-.004l-3.723-.525a.498.498 0 11.139-.986l3.723.525a.498.498 0 01-.069.99m8.377 1.181a.464.464 0 01-.07-.005l-3.723-.524a.498.498 0 11.14-.986l3.723.524a.498.498 0 01-.07.991m8.378 1.181a.516.516 0 01-.07-.005l-3.724-.525a.498.498 0 11.14-.986l3.723.525a.498.498 0 01-.069.991m8.378 1.18a.53.53 0 01-.07-.004l-3.724-.525a.498.498 0 11.14-.986l3.723.525a.497.497 0 01-.07.99m8.378 1.18a.472.472 0 01-.07-.004l-3.723-.525a.498.498 0 11.14-.986l3.722.525a.498.498 0 01-.07.99m8.379 1.182a.472.472 0 01-.07-.005l-3.724-.525a.498.498 0 11.14-.986l3.723.524a.498.498 0 01-.07.992m8.378 1.18a.473.473 0 01-.07-.005l-3.723-.525a.498.498 0 11.139-.986l3.723.525a.498.498 0 01-.07.99m8.379 1.181a.528.528 0 01-.07-.004l-3.724-.525a.498.498 0 11.14-.986l3.723.525a.498.498 0 01-.07.99"
                    id="orange-search-illustration_svg__Fill-48"
                    fill="#FB8825"
                />
                <path
                    d="M226.477 97.2a.476.476 0 01-.07-.006l-1.977-.278a.498.498 0 11.14-.987l1.976.28a.498.498 0 01-.07.99"
                    id="orange-search-illustration_svg__Fill-50"
                    fill="#FB8825"
                />
                <path
                    id="orange-search-illustration_svg__Fill-52"
                    fill="#FCC870"
                    d="M230.16 88.893l-6.262-1.095v15.515l6.246-.317z"
                />
                <path
                    d="M234.236 99.003s1.413-2.432 2.971-1.785c2.206.915 5.233 1.577 8.605 1.764 5.754.319 8.524.212 9.483 1.382.959 1.17 0 2.632 0 2.632h7.7s.427-3.76-2.45-4.631c-2.877-.872-7.603-2.473-13.958-2.246-4.797.17-7.677-3.56-9.488-3.56-4.05 0-4.219 3.549-2.863 6.444"
                    id="orange-search-illustration_svg__Fill-54"
                    fill="#363A43"
                />
                <path
                    d="M79.306 32.797l-3.269 2.36S55.93.949 38.38 28.782c0 0-2.552 4.556-.685 6.783 1.868 2.226 9.786 10.758 9.988 11.27l.725 1.835 1.893-.744s4.556 3.4 6.226 2.591c1.67-.809 5.669-6.306 7.574-7.56 4.43-2.915 18.48 2.42 18.48 2.42l-3.274-12.58z"
                    id="orange-search-illustration_svg__Fill-57"
                    fill="#F7682F"
                />
                <path
                    d="M83.985 30.356c-2.066-11.029-20.22-10.051-20.22-10.051S40.356 5.507 35.755 36.582c0 0 5.682 4.512 10.876 1.416 5.195-3.096 7.25-2.789 10.07-1.413 2.819 1.376 8.322 5.302 13.263 5.085l14.021-11.314z"
                    id="orange-search-illustration_svg__Fill-59"
                    fill="#FCC870"
                />
                <path
                    d="M54.727 36.015s-.334-2.212 1.56-1.673c1.893.538.724 2.75.724 2.75l-2.284-1.077z"
                    id="orange-search-illustration_svg__Fill-61"
                    fill="#F7682F"
                />
                <path
                    d="M67.693 23.258c-1.386 2.81-5.336 8.29-5.132 13.222.203 4.933 4.246 8.329 3.533 12.603-.714 4.275-4.45 7.503.95 12.503s1.015 6.883 4.524 9.267c3.51 2.385 9.172-3.113 8.632-5.922-.542-2.809-1.08-5.517 1.077-7.75 2.158-2.233 8.168-12.164 7.665-17.589-.504-5.426-4.957-9.236-4.957-9.236l-16.292-7.098z"
                    id="orange-search-illustration_svg__Fill-63"
                    fill="#FCC870"
                />
            </g>
        </g>
    </svg>
);

OrangeSearchIllustrationSvg.displayName = 'OrangeSearchIllustrationSvg';
export default OrangeSearchIllustrationSvg;
